import {
  buildFilterCategories,
  fetchStaticFilterData
} from '../../utils/filters/filterOptions'
import FirebaseAPI from '@/api/firebase'

export default {
  namespaced: true,
  state: {
    savedFilters: [],

    // Static filter options that are stored in DBs
    languages: [],
    niches: [],

    // User brands are not technically static (saving ad with new brand creates a new user brand)
    // Ideally this is promoted to its own module, but with the uncertain future of brands in-app we just treat it as static
    userBrands: []
  },
  getters: {
    getFilterCategories: (state, getters, rootState, rootGetters) => {
      return buildFilterCategories({
        savedFilters: state.savedFilters,
        languages: state.languages,
        niches: state.niches,
        userBrands: state.userBrands,
        boards: rootState.BoardsModule.boards,
        folders: rootState.BoardsModule.folders,
        tags: rootState.TagsModule.tags,
        spyderSubscriptions: rootState.SpyderModule.spyderSubscriptions,
        currentProduct: rootGetters['RouterModule/getCurrentRouteProduct']
      })
    },
    getSavedFilters: state => state.savedFilters
  },
  mutations: {
    SET_SAVED_FILTERS (state, filters) {
      state.savedFilters = filters
    },
    SET_LANGUAGES (state, languages) {
      state.languages = languages
    },
    SET_NICHES (state, niches) {
      state.niches = niches
    },
    SET_USER_BRANDS (state, brands) {
      state.userBrands = brands
    }
  },
  actions: {
    async fetchFilterCategories ({ state, commit, dispatch, rootGetters }) {
      await Promise.all([
        dispatch('fetchSavedFilters'),
        (async () => {
          // Initial fetch meant to populate the static options that are stored in DBs
          const team = rootGetters['AuthModule/getTeam']
          const { languages, niches, userBrands } = await fetchStaticFilterData({ team })

          commit('SET_LANGUAGES', languages)
          commit('SET_NICHES', niches)
          commit('SET_USER_BRANDS', userBrands)
        })()
      ])
    },
    async fetchSavedFilters ({ commit }) {
      const filters = await FirebaseAPI.Filters.getSavedFilters()
      commit('SET_SAVED_FILTERS', filters)
    }
  }
}
